<template lang="pug">
b-modal#editProviderGameOff.siteeditor-providergame(
  ref="editProviderGameOff"
  :title="$t('ui.combine.edit_provider_game_off')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl-siteeditor-providergame"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row.mb-2
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="provider_code"
            required
            type="text"
            :dirty="$v.provider_code.$dirty"
            :error="$v.provider_code.$error"
            v-model.trim.lazy="$v.provider_code.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.provider_name')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="provider_name"
            required
            type="text"
            :dirty="$v.provider_name.$dirty"
            :error="$v.provider_name.$error"
            v-model.trim.lazy="$v.provider_name.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.provider_name" :name="$t('ui.provider_name')")
      .col-sm-12.col-md-12.col-lg-12
        .alert.alert-warning.p-1.mb-2.w-100 {{ $t('message.tooltips_sequence') }}
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.game_list')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll.table-responsive(style="max-height: 63vh")
                table.table.table-sm.table-bordered.table-striped.mb-0.table-align-middle
                  thead.thead-dark
                    tr
                      th.text-center(width="10%" v-if="isEditProviderGameAccess")
                        span #
                      th(width="40%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th(width="50%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  tbody.clusterize-content
                    tr(v-if="filterGameList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterGameList")
                      td.actions.text-center(v-if="isEditProviderGameAccess")
                        span
                          a.fa.fa-plus.text-success(href="#" @click="onAdd(item)" :title="$t('ui.add')")
                      td
                        span(:title="item.game_code") {{ item.game_code }}
                      td
                        span(:title="item.game_name") {{ item.game_name }}
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.off_list')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll.table-responsive(style="max-height: 63vh")
                table.table.table-sm.table-bordered.table-striped.mb-0.table-align-middle
                  thead.thead-dark
                    tr
                      th.text-center(width="10%" v-if="isEditProviderGameAccess")
                        span #
                      th(width="40%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th(width="50%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  tbody
                    tr(v-if="filterOffList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterOffList")
                      td.actions.text-center(v-if="isEditProviderGameAccess")
                        span
                          a.fa.fa-trash.text-danger(href="#" @click="onRemove(item)" :title="$t('ui.remove')")
                      td
                        span(:title="item.game_id") {{ item.game_id }}
                      td
                        span(:title="item.game_name") {{ item.game_name }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      offList: [],
      providerGameList: [],
      provider_code: '',
      provider_name: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gameListFilterBy: "name",
      gameListSearch: "",
      offListFilterBy: "name",
      offListSearch: "",
      mapName: false,
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    filterGameListLength() {
      if (this.filterGameList) {
        return this.filterGameList.length;
      } else {
        return 0;
      }
    },
    filterOffListLength() {
      if (this.filterOffList) {
        return this.filterOffList.length;
      } else {
        return 0;
      }
    },
    filterGameList() {
      var freeList = this.providerGameList;
      var groupList = this.offList;
      var list = [];
      if(freeList == null) return list

      for(var i = 0; i < freeList.length; i++) {
        var temp = groupList.filter(item => {
          return item.game_id == freeList[i].game_code;
        })

        if (temp.length == 0) {
          list.push(freeList[i]);
        }
      }

      return list;
    },
    filterOffList() {
      var oList = this.offList;
      var pList = this.providerGameList;
      if(pList == null) return []

      for(var i = 0; i < oList.length; i++) {
        var obj = pList.filter(item => { return item.game_code == oList[i].game_id });
        if (obj.length != 0) {
          oList[i].game_name = obj[0].game_name;

        }
      }

      return oList;
    },
    
    isEditProviderGameAccess() {
      return this.$helpers.showActionButton("e_providergameoff");
    }
  },
  validations: {
    provider_code: {
      required
    },
    provider_name: {
      required,
      alphaNum
    },
  },
  methods: {
    onAdd: function(e) {
      let url = config.providerGameOffAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: this.item.provider_code,
        game_id: e.game_code
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderGameOffList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onRemove: function(e) {
      let url = config.providerGameOffRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: this.item.provider_code,
        game_id: e.game_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderGameOffList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getProviderGameOffList: function() {
      let url = config.providerGameOffListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        provider_code: this.item.provider_code
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.offList = response.data.dt;
                // this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getGameList: function() {
      let url = config.getGameList["oneUrl"];
      var json = {
        platform: this.provider_code.trim().toUpperCase(),
        gametype: this.item.category
      };

      if(this.item.aggregator != null) {
        json.aggregator = this.item.aggregator
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.status == "string" ? response.status == "200" : response.status == 200;
              this.feedback.status = response.statusText;

              if (this.feedback.success == true) {
                this.providerGameList = response.data.game;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.provider_name = this.item.provider_name;
      this.offList = [];
      this.providerGameList = [];
      this.getProviderGameOffList();
      this.getGameList();
    }
  }
};
</script>
